import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, delay, retryWhen, take, tap } from 'rxjs/operators';
import { Socket } from 'socket.io-client';
import { IAppState } from '../app.state';
import { Store } from '@ngrx/store';
import { UsersService } from '@services/users/users.service';
import { Router } from '@angular/router';
import {
  AddNotification,
  DeleteAllNotification,
  ENotificationsActions,
  SetNotifications,
  SubscribeToNotifications,
} from './notifications.actions';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from '../../../../environments/environment';
import { EMPTY } from 'rxjs';

@Injectable()
export class NotificationsEffects {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  notificationsWS?: WebSocketSubject<any>;
  private socket!: Socket;

  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _usersService: UsersService,
    private _router: Router
  ) {}

  $subscribeToNotifications = createEffect(
    () =>
      this._actions$.pipe(
        ofType<SubscribeToNotifications>(
          ENotificationsActions.SubscribeToNotifications
        ),
        tap(action => {
          const id = action.userId;
          this.setupWebSocket(id);
        })
      ),
    { dispatch: false }
  );

  private setupWebSocket(userId: number) {
    this.notificationsWS = webSocket(
      `${environment.wsUrl}ws/notifications/${userId}/`
    );

    this.notificationsWS
      .pipe(
        retryWhen(errors =>
          errors.pipe(
            tap(err => console.error('Reconnecting...', err)),
            delay(3000),
            take(5)
          )
        ),
        catchError(err => {
          console.error('WebSocket connection failed after retries:', err);
          return EMPTY;
        })
      )
      .subscribe({
        next: msg => {
          if (Array.isArray(msg.detail)) {
            this._store.dispatch(new SetNotifications(msg.detail));
          } else if (msg.detail.notification) {
            this._store.dispatch(new AddNotification(msg.detail));
          }
        },
        error: err => console.error(err),
      });
  }

  $getDeleteAllNotification = createEffect(
    () =>
      this._actions$.pipe(
        ofType<DeleteAllNotification>(
          ENotificationsActions.DeleteAllNotification
        ),
        tap(() => {
          this.notificationsWS?.next({ action: 'delete' });
        })
      ),
    { dispatch: false }
  );

  $getOldNotifications = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<SubscribeToNotifications>(
          ENotificationsActions.ReadNotifications
        ),
        tap(() => {
          this.notificationsWS?.next({ is_received: true });
        })
      );
    },
    { dispatch: false }
  );
}
